/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VSTAStaking, VSTAStakingInterface } from "../VSTAStaking";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_activePoolAddress",
        type: "address",
      },
    ],
    name: "ActivePoolAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "AssetSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
    ],
    name: "BorrowerOperationsAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_F_ASSET",
        type: "uint256",
      },
    ],
    name: "F_AssetUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_F_VST",
        type: "uint256",
      },
    ],
    name: "F_VSTUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "SentToTreasury",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newStake",
        type: "uint256",
      },
    ],
    name: "StakeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_F_Asset",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_F_VST",
        type: "uint256",
      },
    ],
    name: "StakerSnapshotsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "AssetGain",
        type: "uint256",
      },
    ],
    name: "StakingGainsAssetWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "VSTGain",
        type: "uint256",
      },
    ],
    name: "StakingGainsVSTWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_totalVSTAStaked",
        type: "uint256",
      },
    ],
    name: "TotalVSTAStakedUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_treausury",
        type: "address",
      },
    ],
    name: "TreasuryAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_troveManager",
        type: "address",
      },
    ],
    name: "TroveManagerAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_VSTATokenAddress",
        type: "address",
      },
    ],
    name: "VSTATokenAddressSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
    ],
    name: "VSTTokenAddressSet",
    type: "event",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "F_ASSETS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "F_VST",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "activePoolAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "borrowerOperationsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_treasury",
        type: "address",
      },
    ],
    name: "changeTreasuryAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getPendingAssetGain",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getPendingVSTGain",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_AssetFee",
        type: "uint256",
      },
    ],
    name: "increaseF_Asset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_VSTFee",
        type: "uint256",
      },
    ],
    name: "increaseF_VST",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "sentToTreasuryTracker",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vstaTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_activePoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_treasury",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "snapshots",
    outputs: [
      {
        internalType: "uint256",
        name: "F_VST_Snapshot",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_VSTAamount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalVSTAStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManagerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_VSTAamount",
        type: "uint256",
      },
    ],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vstToken",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vstaToken",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type VSTAStakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VSTAStakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VSTAStaking__factory extends ContractFactory {
  constructor(...args: VSTAStakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<VSTAStaking> {
    return super.deploy(overrides || {}) as Promise<VSTAStaking>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VSTAStaking {
    return super.attach(address) as VSTAStaking;
  }
  override connect(signer: Signer): VSTAStaking__factory {
    return super.connect(signer) as VSTAStaking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VSTAStakingInterface {
    return new utils.Interface(_abi) as VSTAStakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VSTAStaking {
    return new Contract(address, _abi, signerOrProvider) as VSTAStaking;
  }
}
